<template>
  <div id="legalNotice" class="d-flex flex-column justify-content-around align-items-left" v-if="legalNoticeLg.lg1.length > 0">
    <div id="bloc1" v-if="legalNoticeLg.lg1">
      <div>
        <span class="lg1" v-html="rawHtml(legalNoticeLg.lg1[0].ta_value)"></span> 
        <span class="lg2" v-html="rawHtml(legalNoticeLg.lg2[0].ta_value)"></span> 
      </div>
    </div>
    <div id="bloc2" v-if="legalNoticeLg.lg1.length > 2">
      <div>
        <span class="lg1" v-html="rawHtml(legalNoticeLg.lg1[1].ta_value)"></span>
        <span class="lg2" v-html="rawHtml(legalNoticeLg.lg2[1].ta_value)"></span>
      </div>
        <div class="lg1" v-html="rawHtml(legalNoticeLg.lg1[2].ta_value)"></div>
        <div class="lg2" v-html="rawHtml(legalNoticeLg.lg2[2].ta_value)"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MercureRatesHorizontalV1LegalNoticeCenter',
  props: {
    legalNoticeLg: Object
  },
  methods: {
    rawHtml (value) {
      return value
    }
  }
}
</script>


<style lang="scss" scoped>
  $srcWidth: 1920;
  $srcHeight: 1200;
  @import "../../../../_mercure.scss";

  #legalNotice {
    font-family: "National-Medium";
  @include fontSize(26);
    line-height: 1rem;

    position: absolute;
    bottom: 0px;
    @include widthPercent(895);
    @include heightPercent(285);
    justify-content: space-evenly!important;

    #bloc2 {
      //margin-top: 0.9rem;
    }

    span+span:not(:empty):before {
      content: '- ';
    }
  }

</style>


// WEBPACK FOOTER //
// src/components/mercure/rates/horizontal/v1/services/legalNoticeCenter.vue